import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from '../../../../../../environments/environment';
import { imageatch_detData } from '../../../../../@core/interfaces/masters/imageatch_det';

@Component({
  selector: 'ngx-printer-header',
  templateUrl: './printer-header.component.html',
  styleUrls: ['./printer-header.component.scss']
})
export class PrinterHeaderComponent implements OnInit {

  @Input() psDetails;
  @Input() title;
  @Input() srcname;
  @Input() srcname2='/assets/images/white.png';
  @Output() dataEvent: EventEmitter<any> = new EventEmitter<any>();
  @Input() billTitle;
  
  intervar:any;
  cdate=new Date();

  private tenantId = localStorage.getItem("tenantId");
  private branchId = localStorage.getItem("branchId");
  private logosrcname = localStorage.getItem("logo");
  protected readonly unsubscribe$ = new Subject<void>();

  CurrentTime:any;
  pageSize;
  constructor(private router: Router,
    private iatchSrvc: imageatch_detData) { 
    this.intervar=setInterval(() => {
      // var date=(new Date()).toLocaleString();
      var date = new Date();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var sec = date.getSeconds();

      var ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      var _minutes = minutes < 10 ? '0' + minutes : minutes;
      var _sec = sec < 10 ? '0' + sec : sec;
      var strTime = hours + ':' + _minutes + ':' + _sec + ' ' + ampm;

      this.CurrentTime = strTime;//new Date().getHours() + ':' + new Date().getMinutes() + ':'+  new Date().getSeconds()

    }, 1);
  }

  ngOnInit(): void {
  this.srcname=this.logosrcname;
  }
  ngOnChanges(changes: any): void {
    if(this.psDetails?.orientation?.toLowerCase()=='portrait')
      this.portraitValue();
    else  if(this.psDetails?.orientation?.toLowerCase()=='landscape')
      this.landscapeValue();
    if(!!this.psDetails?.topHeaderlogoCategory)
      this.onLogoChange([{value:this.psDetails?.topHeaderlogoCategory}],'logo1')
    if(!!this.psDetails?.topHeader_2_logoCategory)
      this.onLogoChange([{value:this.psDetails?.topHeader_2_logoCategory}],'logo2')
    if(this.psDetails?.paperSize?.toLowerCase()!='custom'){
        this.pageSize=this.psDetails?.paperSize;
    }
  }
  onLogoChange(event,type){
    var logosrc=this.getlogoLocal(event[0]?.value);
    if(!!logosrc){
        if("logo1"==type)
            this.srcname = logosrc;
        else if("logo2"==type)
            this.srcname2 = logosrc;
    }
    else{
      this.iatchSrvc.getById(`${environment.apiUrl}/ImageAtchDet/${this.tenantId}/${this.branchId}/${event[0]?.value}`).pipe(takeUntil(this.unsubscribe$)).subscribe((datas: any) => {
        var x= datas.filter(x=>x.phyId==null && x.empId==null && x.patId==null&&x.tenantId===this.tenantId && x.category==event[0]?.value);
        if(x.length>0)
        {
          x[0].isCreate = true;
          x[0].isEdit = true;
          this.iatchSrvc.create(`${environment.apiUrl}/ImageAtchDet/${this.tenantId}/${this.branchId}/download`,x[0]).pipe(takeUntil(this.unsubscribe$)).subscribe((downloaddata: any) => {
            if("logo1"==type){
                this.srcname = 'data:image/jpeg;base64,' + downloaddata;
                this.logoLocalSave(event[0]?.value,this.srcname);
            }
            else if("logo2"==type){
                this.srcname2 = 'data:image/jpeg;base64,' + downloaddata;
                this.logoLocalSave(event[0]?.value,this.srcname2);
            }
          }, (error) => {

          }, () => {

          });
        }
      },error=>{

      });
    }
  }
  logoLocalSave(name,src){
    localStorage.setItem(name,src);
  }
  getlogoLocal(name){
    return localStorage.getItem(name);
  }
  onChange() { 
    var link = "/pages/masters/printersettings/?data";
    this.router.navigate([`${link.split('?')[0]}`], { queryParams: { psID: this.psDetails?.id } });

  }
  onAddNew(){
    var link = "/pages/masters/printersettings/?data";
    this.router.navigate([`${link.split('?')[0]}`], { queryParams: { psAdd: 'new' } }); 
  }

  portraitValue(){ 
    this.oriantaionChange("Portrait");
    document.getElementById("portrait")?.setAttribute("class","p-f-wrap p-f-wrap2 selected");
    document.getElementById("landscape")?.setAttribute("class","p-f-wrap p-f-wrap2");
  }

  landscapeValue(){ 
    document.getElementById("landscape")?.setAttribute("class","p-f-wrap p-f-wrap2 selected");
    document.getElementById("portrait")?.setAttribute("class","p-f-wrap p-f-wrap2");
    this.oriantaionChange("Landscape");
  }

  oriantaionChange(value){
    this.psDetails.orientation=value; 
    this.dataEvent.emit(this.psDetails)
  }
  pageSizeChange(event){
    this.psDetails.paperSize=event;
    this.dataEvent.emit(this.psDetails)
  }
  ngOnDestroy(): void {
    clearInterval(this.intervar);
  }

}
